import { FunctionComponent, PropsWithChildren } from 'react';
import { BoxSectionProps } from './BoxSectionProps';

export const BoxSection: FunctionComponent<PropsWithChildren<BoxSectionProps>> = ({
  className,
  title,
  footer,
  children
}) => {
  return (
    <div className={className}>
      {title ? (
        <h4 className="pb-1.5 text-text-secondary text-xs font-medium tracking-wider">{title.toUpperCase()}</h4>
      ) : undefined}
      {children}
      {footer ? <h5 className="pt-1.5 text-text-secondary text-xs tracking-wider opacity-50">{footer}</h5> : undefined}
    </div>
  );
};
